import { useEffect } from "react";
import { useAppDispatch } from "../../redux/store";
import { User } from "../../model/user/User";
import { useNavigate } from "react-router-dom";
import { onAppStart } from "../../axios/onAppStart";
import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import { userActions } from "../../redux/user/user.slice";
import { IMPERSONATION_KIND_KEY } from "../../redux/store-utils";
import { ImpersonationKind } from "../../model/user/types/ImpersonationKind.enum";

export const Impersonate: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const onMessage = (ev: MessageEvent) => {
      if (
        ev.origin !== window.location.origin ||
        ev.data?.type !== "IMPERSONATE_TOKEN" ||
        ev.source !== window.opener
      ) {
        return;
      }

      const token = ev.data.token as string | undefined;
      const user = ev.data.user as User | undefined;
      if (!token || !user) {
        return;
      }

      sessionStorage.setItem(
        process.env.REACT_APP_IMPERSONATION_FLAG_KEY!,
        "1",
      );

      sessionStorage.setItem(
        process.env.REACT_APP_LOCAL_STORAGE_TOKEN_IMPERSONATION_KEY!,
        token,
      );

      sessionStorage.setItem(
        IMPERSONATION_KIND_KEY,
        ev.data.kind === ImpersonationKind.SUPPORT
          ? ImpersonationKind.SUPPORT
          : ImpersonationKind.LINKED,
      );

      dispatch(userActions.setLoggedInUserManuallyFromSessionStorage(user));
      onAppStart(() => {
        navigate("/", { replace: true });
      });
    };

    window.addEventListener("message", onMessage);

    window.opener?.postMessage(
      { type: "IMPERSONATE_READY" },
      window.location.origin,
    );

    return () => window.removeEventListener("message", onMessage);
  }, [dispatch, navigate]);

  useEffect(() => {
    // in case nothing happens after 15 seconds, just go back to home page
    // Or something went wrong and we don't want to leave the user stuck on this page
    const id = setTimeout(() => {
      // Full reload rather than a router navigate: this tab booted with the
      // impersonation persistor and an empty session storage, so an in-app
      // navigation would leave it in a half-built state. Reloading lets it come
      // back up as an ordinary main-account tab.
      window.location.replace("/");
    }, 15000);

    return () => clearTimeout(id);
  }, [navigate]);

  return <SpinnerFullScreen />;
};
